<div #layerElement class="mark-container" [style]="styles">
  <ng-container *ngFor="let marker of markers">
    <ca-player-timeline-conversationmark-marker
      (markerClick)="onMarkerClick($event)"
      [marker]="marker"></ca-player-timeline-conversationmark-marker>
  </ng-container>
</div>
